import { Component } from '@angular/core';
import { IntroComponent } from './intro.component';

@Component({
  selector: 'eid-intro-desktop',
  templateUrl: './intro.desktop.component.html',
  styleUrls: ['./intro.desktop.component.scss']
})
export class IntroDesktopComponent extends IntroComponent {}
